import React, { Component } from "react";
import Layout from "./Layout";
import PropagateLoader from "react-spinners/PropagateLoader";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faFileUpload,
  faUpload,
  faImage,
  faFilePdf,
  faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import {
  Modal,
  Button,
  ButtonGroup,
  Row,
  Col,
  OverlayTrigger,
  Popover,
  Form,
} from "react-bootstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ReactTooltip from "react-tooltip";
import Select from "react-select";

import "react-awesome-lightbox/build/style.css";

class Usuarios extends Component {
  constructor(props) {
    super(props);
    this.GetActionFormat = this.GetActionFormat.bind(this);
    this.state = {
      // Estado relacionado con el modelo
      id: "",
      usuario: "",
      password: "",
      nombre: "",
      ap_paterno: "",
      ap_materno: "",
      ambitos: [],
      api_token: "",
      ambitosOptions: [],

      // Estados para la ventana modal
      modal: false, // ventana modal generica para modificar y Nuevo cerrada
      modalEliminar: false, //Modal Eliminar
      modalVisualizar: false, //Modal Visualizar
      modalAccion: "", // Acción del boton principal de la ventana modal para el switch
      modalTitle: "", // Titulo para la ventana modal generica
      frm_lista_documentos: [], // Lista de documentos del registro
      frm_archivo: null,
      frm_descripcion_doc: "",
      usuarios: [], // Listado de elementos para la tabla
      loading: false,
    };
  }

  componentDidMount = () => {
    this.cargaTabla();
    this.cargaAmbitos();
  };
  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  cargaTabla = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/Usuario?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.setState({ usuarios: res.data, loading: false });
    });
  };

  cargaAmbitos = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/AmbitoOpt?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.setState({ ambitosOptions: res.data, loading: false });
    });
  };

  cargaDocumentos = (id) => {
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/Documento/" +
        1 +
        "/usuario/" +
        id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.closeModalDocumentos();
      this.setState({ frm_lista_documentos: res.data, loading: false });
    });
  };

  showModalEliminar = () => {
    this.setState({ modalEliminar: true });
  };

  closeModalEliminar = () => {
    this.setState({ modalEliminar: false });
  };

  showModalVisualizar = () => {
    this.setState({ modalVisualizar: true });
  };

  closeModalVisualizar = () => {
    this.setState({ modalVisualizar: false });
  };

  showModalDocumentos = () => {
    this.setState({ modalDocumentos: true });
  };

  closeModalDocumentos = () => {
    this.setState({ modalDocumentos: false });
  };

  showModal = () => {
    this.setState({ modal: true });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  onFileChange = (event) => {
    this.setState({
      frm_archivo: event.target.files[0],
    });
  };

  sube_documento = (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    let datosFormulario = new FormData();
    datosFormulario.append("archivo", this.state.frm_archivo);
    datosFormulario.append("descripcion", this.state.frm_descripcion_doc);
    datosFormulario.append("tipo", "jpg");
    datosFormulario.append("anexo_cve", "usuario");
    datosFormulario.append("fx_id", this.state.id);
    datosFormulario.append("ambito_id", this.state.ambito_id);
    datosFormulario.append("usuario_id", this.state.usuario_id);
    datosFormulario.append("api_token", localStorage.api_token);

    let config = {};
    axios
      .post(
        "http://143.198.191.211/api/Documento/",
        datosFormulario,
        config
      )
      .then((res) => {
        this.closeModalDocumentos();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  ModalNuevo = () => {
    this.showModal();
    this.setState({
      modalLabel: "Guardar",
      variante: "primary",
      modalAccion: "insert",
      modalTitle: "Registro nuevo",
      id: "",
      usuario: "",
      password: "",
      nombre: "",
      ap_paterno: "",
      ap_materno: "",
      ambitos: "",
      api_token: "",
    });
  };

  ModalModificar = (row) => {
    this.showModal();
    let ambitosModificacion = "";
    // obtengo el arreglo de los ambitos al seleccionar la opcion modificar
    if (row.ambitos && row.ambitos.length) {
      let valuesToModify = row.ambitos.split(",");
      let valuesToModifyInt = valuesToModify.map((el) => {
        let n = Number(el);
        return n;
      });

      ambitosModificacion = this.state.ambitosOptions.filter((ambiOp) =>
        valuesToModifyInt.includes(ambiOp.value)
      );
    }

    this.setState({
      modalLabel: "Modificar",
      variante: "warning",
      modalAccion: "update",
      modalTitle: "Modificación",
      id: row.id,
      usuario: row.usuario,
      password: row.password,
      nombre: row.nombre,
      ap_paterno: row.ap_paterno,
      ap_materno: row.ap_materno,
      ambitos: ambitosModificacion,
      api_token: row.api_token,
    });
  };

  ModalVisualizar = (row) => {
    this.showModalVisualizar();

    let ambitosVisualizacion = "";
    // obtengo el arreglo de los ambitos al seleccionar la opcion modificar
    if (row.ambitos && row.ambitos.length) {
      let valuesToModify = row.ambitos.split(",");
      let valuesToModifyInt = valuesToModify.map((el) => {
        let n = Number(el);
        return n;
      });

      ambitosVisualizacion = this.state.ambitosOptions.filter((ambiOp) =>
        valuesToModifyInt.includes(ambiOp.value)
      );
    }

    this.setState({
      modalLabel: "Visualizar",
      variante: "warning",
      modalAccion: "view",
      modalTitle: "Visualizar",
      id: row.id,
      usuario: row.usuario,
      password: row.password,
      nombre: row.nombre,
      ap_paterno: row.ap_paterno,
      ap_materno: row.ap_materno,
      ambitos: ambitosVisualizacion,
      api_token: row.api_token,
    });
  };

  ModalDocumentos = (row) => {
    this.showModalDocumentos();
    this.setState({
      modalLabel: "Documentos",
      variante: "warning",
      modalAccion: "document",
      modalTitle: "Documentos",
      id: row.id,
      usuario: row.usuario,
      password: row.password,
      nombre: row.nombre,
      ap_paterno: row.ap_paterno,
      ap_materno: row.ap_materno,
      ambito_id: row.ambito_id,
      api_token: row.api_token,
    });
  };

  ModalEliminar = (row) => {
    this.showModalEliminar();
    this.setState({
      modalAccion: "delete",
      id: row.id,
      usuario: row.usuario,
      password: row.password,
      nombre: row.nombre,
      ap_paterno: row.ap_paterno,
      ap_materno: row.ap_materno,
      ambito_id: row.ambito_id,
      api_token: row.api_token,
    });
  };

  ejecutar = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    switch (this.state.modalAccion) {
      case "update":
        this.actualiza();
        break;
      case "insert":
        this.registra();
        break;
      case "delete":
        this.borra();
        break;
      default:
    }
  };

  registra = () => {
    let ambitosCadena = this.state.ambitos.map((el) => el.value).join();

    let data = {
      //Recoger la información para el registro
      usuario: this.state.usuario,
      password: this.state.password,
      nombre: this.state.nombre,
      ap_paterno: this.state.ap_paterno,
      ap_materno: this.state.ap_materno,
      ambitos: ambitosCadena,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios
      .post("http://143.198.191.211/api/Usuario", data, config)
      .then((res) => {
        this.closeModal();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  actualiza = () => {
    let ambitosCadena =
      this.state.ambitos && this.state.ambitos.length
        ? this.state.ambitos.map((el) => el.value).join()
        : "";

    let data = {
      //Recoger la información para el registro
      id: this.state.id,
      usuario: this.state.usuario,
      password: this.state.password,
      nombre: this.state.nombre,
      ap_paterno: this.state.ap_paterno,
      ap_materno: this.state.ap_materno,
      ambitos: ambitosCadena,

      api_token: localStorage.api_token,
    };
    let config = {};

    axios
      .put(
        "http://143.198.191.211/api/Usuario/" + this.state.id,
        data,
        config
      )
      .then((res) => {
        this.closeModal();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  borra = () => {
    let data = {
      api_token: localStorage.api_token,
    };
    let config = {};
    axios
      .delete(
        "http://143.198.191.211/api/Usuario/" +
        this.state.id +
        "?api_token=" +
        localStorage.api_token,
        data,
        config
      )
      .then((res) => {
        this.closeModalEliminar();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  onChangeUsuario = (e) => {
    this.setState({ usuario: e.target.value });
  };

  onChangePassword = (e) => {
    this.setState({ password: e.target.value });
  };

  onChangeNombre = (e) => {
    this.setState({ nombre: e.target.value });
  };

  onChangeApPaterno = (e) => {
    this.setState({ ap_paterno: e.target.value });
  };

  onChangeApMaterno = (e) => {
    this.setState({ ap_materno: e.target.value });
  };

  onChangeAmbitoId = (e) => {
    this.setState({ ambito_id: e.target.value });
  };

  onChangeAmbitos = (inputValue) => {
    this.setState({ ambitos: inputValue });
    /*
    let ambitos = [];
    if (inputValue && inputValue.length) {

      inputValue.map((ambi) => {
        ambitos.push(ambi.value);
      });
    
    this.setState({ ambitos: ambitos.join() });
     */
  };

  onChangefrm_descripcion_doc = (e) => {
    this.setState({ frm_descripcion_doc: e.target.value });
  };

  GetAmbitosFormat = (cell, row) => {
    return row.ambitos && row.ambitos.length
      ? row.ambitos.split(",").length
      : 0;
  };
  GetActionFormat = (cell, row) => {
    return (
      <div>
        <ButtonGroup size="sm">
          <button
            type="button"
            className="btn btn-outline-info btn-sm"
            size="sm"
            onClick={() => this.ModalVisualizar(row)}
            data-tip="Visualizar"
          >
            <FontAwesomeIcon icon={faEye} size="lg" />
          </button>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            size="sm"
            onClick={() => this.ModalModificar(row)}
            data-tip="Modificar"
          >
            <FontAwesomeIcon icon={faEdit} size="lg" />
          </button>

          <button
            type="button"
            className="btn btn-outline-danger btn-sm"
            size="sm"
            onClick={() => this.ModalEliminar(row)}
            data-tip="Eliminar"
            disabled
          >
            <FontAwesomeIcon icon={faTrash} size="lg" />
          </button>
        </ButtonGroup>
      </div>
    );
  };

  render() {
    const columns = [
      {
        dataField: "id",
        text: "ID",
        hidden: true,
        sort: true,
        headerStyle: () => {
          return {
            width: "100px",
            zIndex: "98",
          };
        },
      },
      {
        dataField: "usuario",
        text: "Usuario",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },

      {
        dataField: "nombre",
        text: "Nombre",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "ap_paterno",
        text: "Ap Paterno",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "ap_materno",
        text: "Ap Materno",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "",
        text: "Ámbitos",
        formatter: this.GetAmbitosFormat,
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },

      {
        dataField: "",
        text: "Acción",
        formatter: this.GetActionFormat,
        headerStyle: () => {
          return {
            width: "95px",
            zIndex: "99",
          };
        },
      },
    ];

    const { SearchBar } = Search;
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h3">Ayuda</Popover.Title>
        <Popover.Content>{this.state.input_tooltip}</Popover.Content>
      </Popover>
    );

    return (
      <Layout>
        <ToastContainer />
        <div
          id="cargando"
          className={this.state.loading ? "parentDisable" : ""}
          width="100%"
        >
          <div className="overlay-box">
            <PropagateLoader
              // css={}
              sizeUnit={"px"}
              size={25}
              color={"#000000"}
              loading={this.state.loading}
            />
          </div>
        </div>

        <div className="container mt-3">
          <div className="row">
            <div className="col">
              <h3 className="d-inline">Catálogo de Usuarios</h3>
              <br />
              <small className="text-muted">
                Registre Elimine o Modifique Usuarios, estos elementos estan
                ligados a los usuarios de el sistema.
              </small>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12 ">
              <ToolkitProvider
                keyField="id"
                data={this.state.usuarios}
                columns={columns}
                bootstrap4
                search
              >
                {(props) => (
                  <div>
                    <div className="row">
                      <div className="col-6">
                        <button
                          className="btn btn-primary"
                          onClick={this.ModalNuevo}
                          data-tip="Nuevo"
                        >
                          <FontAwesomeIcon icon={faPlus} /> Nuevo
                        </button>
                      </div>
                      <div className="col-6 text-right">
                        <SearchBar
                          placeholder="Buscar..."
                          {...props.searchProps}
                          className="self-align-end"
                        />
                      </div>
                    </div>

                    <BootstrapTable
                      {...props.baseProps}
                      pagination={paginationFactory()}
                      hover
                    />
                  </div>
                )}
              </ToolkitProvider>{" "}
            </div>
          </div>
        </div>

        <Modal //***************************Modal para nuevo y modificar
          show={this.state.modal}
          onHide={this.closeModal}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Row>
              {" "}
              <Col xs="4">
                <Form.Label>
                  Usuario:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="usuario"
                  value={this.state.usuario}
                  onChange={this.onChangeUsuario}
                />
              </Col>
              <Col xs="4">
                <Form.Label>
                  Password:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  value={this.state.password}
                  onChange={this.onChangePassword}
                />
              </Col>
              <Col xs="4">
                <Form.Label>
                  Nombre:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="nombre"
                  value={this.state.nombre || ""}
                  onChange={this.onChangeNombre}
                />
              </Col>
              <Col xs="4">
                <Form.Label>
                  Ap Paterno:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="ap_paterno"
                  value={this.state.ap_paterno || ""}
                  onChange={this.onChangeApPaterno}
                />
              </Col>
              <Col xs="4">
                <Form.Label>
                  Ap Materno:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="ap_materno"
                  value={this.state.ap_materno || ""}
                  onChange={this.onChangeApMaterno}
                />
              </Col>
              <Col xs="4">
                {/*
                <Form.Control
                  type="text"
                  name="ambitos"
                  value={this.state.ambitos}
                  onChange={this.onChangeApiToken}
                />
                */}
              </Col>
              <Col xs="12">
                <Form.Label>
                  Ámbitos:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Select
                  value={this.state.ambitos}
                  isMulti
                  options={this.state.ambitosOptions}
                  onChange={this.onChangeAmbitos}
                />
              </Col>
            </Form.Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Cancelar
            </Button>
            <Button
              variant={this.state.variante}
              onClick={this.ejecutar}
              disabled={this.state.loading}
            >
              {this.state.modalLabel}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para eliminar
          show={this.state.modalEliminar}
          onHide={this.closeModalEliminar}
          size="sm"
          centered
        >
          <Modal.Header>
            <Modal.Title>Eliminar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Seguro que desea eliminar este registro{" "}
            <strong>{this.state.nom_direccion}</strong> ?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalEliminar}>
              Cancelar
            </Button>
            <Button
              variant="danger"
              onClick={this.ejecutar}
              disabled={this.state.loading}
            >
              Eliminar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para visializar
          show={this.state.modalVisualizar}
          onHide={this.closeModalVisualizar}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header>
            <Modal.Title>Visualizar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Modal.Body className="show-grid">
              <Row>
                <Col xs={12}>
                  <h5>Datos del Registro</h5>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Usuario:
                    </Col>
                    <Col xs={10}>{this.state.usuario}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Password:
                    </Col>
                    <Col xs={10}>{this.state.password}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Nombre:
                    </Col>
                    <Col xs={10}>{this.state.nombre}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Ap Paterno:
                    </Col>
                    <Col xs={10}>{this.state.ap_paterno}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Ap Materno:
                    </Col>
                    <Col xs={10}>{this.state.ap_materno}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Ambitos Asignados:
                    </Col>
                    <Col xs={10}>
                      {this.state.ambitos && this.state.ambitos.length
                        ? this.state.ambitos.map((ambi) => {
                          return (
                            <h5>
                              <span
                                key={ambi.value}
                                className="badge bg-primary rounded-pill text-light"
                              >
                                {ambi.label}
                              </span>
                            </h5>
                          );
                        })
                        : "No hay ambitos asignados"}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalVisualizar}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para Documentos
          show={this.state.modalDocumentos}
          onHide={this.closeModalDocumentos}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header>
            <Modal.Title>Documentos</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Modal.Body>
              <Form.Row>
                <Col xs="12">
                  <Form.Label>
                    Descripcion del Archivo:
                    <OverlayTrigger
                      trigger="focus"
                      placement="right"
                      overlay={popover}
                    >
                      <Button
                        variant="light"
                        onClick={(e) => {
                          this.setState({
                            input_tooltip:
                              "Ingrese un texto descriptivo del documento que se va a subir.",
                          });
                        }}
                      >
                        <FontAwesomeIcon icon={faQuestionCircle} />
                      </Button>
                    </OverlayTrigger>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="frm_descripcion_doc"
                    onChange={this.onChangefrm_descripcion_doc}
                  />
                </Col>
              </Form.Row>
              <Form.Row>
                <Col xs="12">
                  <br />
                  <label htmlFor="file-upload" className="custom-file-upload">
                    <FontAwesomeIcon icon={faUpload} /> Seleccionar Archivo PDF
                    o Imagen
                  </label>
                  <input
                    id="file-upload"
                    type="file"
                    onChange={this.onFileChange}
                    accept="image/png, image/jpeg, application/pdf"
                    className="btnSubir"
                  />
                </Col>
              </Form.Row>
            </Modal.Body>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalDocumentos}>
              Cancelar
            </Button>
            <Button variant={this.state.variante} onClick={this.sube_documento}>
              Guardar Documento
            </Button>
          </Modal.Footer>
        </Modal>

        <ReactTooltip />
      </Layout>
    );
  }
}

export default Usuarios;
